import { setMessageResponse, toggleLoadingIndicator } from "../system/actions";
import { AppThunk } from "../thunks";
import {postResgisterGeiInventoryAPI,getAlLGeiInventoryTableByUserAPI,deleteGeiInventoryByIdAPI, getAllGeiInventoryFilterAPI,getAllGeiInventoryTableAPI,putResgisterGeiInventoryAPI,getGeiInventoryByIdAPI,getAllEstablishmentByGeiInventoryIdAPI,
    postRegisterestablishmentGeiInventoryAPI
} from "../../services/restcall";
import { MessageResponse } from "../system/types";
import { serverMessages } from "../serverMessages";
import { GeiInventory } from "./types";
import { openNotification } from "../../globals/Components/Notification/Notificaction";
import validateMessages from "../../globals/Inputs/validateMessages";


export const getAlLGeiInventoryTableByUser = (page:number, pageSize:number,filter:string): AppThunk => async (dispatch) => {
    
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getAlLGeiInventoryTableByUserAPI(page,pageSize,filter);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));    
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};



export const getAllGeiInventoryFilter = (filter:string): AppThunk => async (dispatch) => {
    
    //dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getAllGeiInventoryFilterAPI(filter);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));    
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getAllGeiInventoryTable = (page:number, pageSize:number,filter:string,order:string): AppThunk => async (dispatch) => {
    
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getAllGeiInventoryTableAPI(page, pageSize,filter,order);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));    
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};


export const postResgisterGeiInventor = (value:GeiInventory): AppThunk => async (dispatch) => {
    
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    
    const responseData = await postResgisterGeiInventoryAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);  
        openNotification("Advertencia",message.message[0]);      
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));    
        dispatch(toggleLoadingIndicator(false));
        openNotification("Ingreso","Gei Inventario "+validateMessages.registerSuccess); 
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const postResgisterEstablishmentGeiInventor = (value:Object): AppThunk => async (dispatch) => {
    
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    
    const responseData = await postRegisterestablishmentGeiInventoryAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);  
        openNotification("Advertencia",message.message[0]);      
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));    
        dispatch(toggleLoadingIndicator(false));
        openNotification("Ingreso","Establecimiento "+validateMessages.registerSuccess); 
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const putResgisterGeiInventory = (value:GeiInventory): AppThunk => async (dispatch) => {
    
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await putResgisterGeiInventoryAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);     
        openNotification("Advertencia",message.message[0]);         
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));    
        dispatch(toggleLoadingIndicator(false));
        openNotification("Actualización","Gei Inventario "+ validateMessages.updateSuccess);  
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getGeiInventoryById = (value:string): AppThunk => async (dispatch) => {
    
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getGeiInventoryByIdAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));    
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const deleteGeiInventoryById = (value:string): AppThunk => async (dispatch) => {
    
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await deleteGeiInventoryByIdAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
        openNotification("Advertencia",message.message[0]);      
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));    
        dispatch(toggleLoadingIndicator(false));
        openNotification("Inventario GEI ",validateMessages.deleteSuccess);      
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getAllEstablishmentByGeiInventoryId = (page:number, pageSize:number,id:string,filter:string,orderYear:string): AppThunk => async (dispatch) => {
    
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getAllEstablishmentByGeiInventoryIdAPI(page, pageSize ,id,filter,orderYear);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));    
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};
